import { ReactNode } from "react";

import { Card, Group, Stack, Text } from "@mantine/core";

export const PropertyBox = ({
  label,
  value,
  description,
}: {
  label: string;
  value: ReactNode;
  description?: ReactNode;
}) => (
  <Stack spacing={8}>
    <Text size="sm" weight={500}>
      {label}
    </Text>
    {description && <Text size="sm">{description}</Text>}
    <Card withBorder p={14}>
      <Group position="apart" noWrap>
        {value}
      </Group>
    </Card>
  </Stack>
);
